module.exports = __webpack_public_path__ + "static/media/Infographic.335788c0.svg";